import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';
import { useCallback, useEffect, useState } from 'react';

export const SuppressIfModalIsPresent = ({
	children,
}: React.PropsWithChildren<unknown>): JSX.Element => {
	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();
	const [isVisible, setIsVisible] = useState(true);

	const handleVisibilityChange = useCallback(
		(modalOnScreen: boolean) => {
			const shouldShow = !modalOnScreen;

			if (!shouldShow) {
				fireAnalyticsEvent({
					eventType: 'operational',
					action: 'suppressed',
					actionSubject: 'screenSpaceFlags',
				});
			}

			setIsVisible(shouldShow);
		},
		[fireAnalyticsEvent],
	);

	useEffect(() => {
		const modalOnScreen = !!globalThis.document.querySelector(
			'.atlaskit-portal-container .atlaskit-portal [role=dialog]',
		);

		handleVisibilityChange(modalOnScreen);
	}, [handleVisibilityChange]);

	return FeatureGates.checkGate('post-office-screen-space-flags-modal-detector') ? (
		<>{isVisible && children}</>
	) : (
		<>{children}</>
	);
};
